import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ToolDistributionChart = ({ data }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">
        AI Tool Usage Distribution
      </h3>
      <div className="w-full h-48 md:h-64" aria-label="AI tool usage distribution bar chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="tool" 
              stroke="var(--color-muted-foreground)" 
              style={{ fontSize: '12px' }} 
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)" 
              style={{ fontSize: '12px' }} 
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'var(--color-popover)',
                border: '1px solid var(--color-border)',
                borderRadius: '8px'
              }}
            />
            <Bar 
              dataKey="count" 
              fill="var(--color-secondary)" 
              radius={[8, 8, 0, 0]} 
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ToolDistributionChart;